
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { 
  Settings,
  Link,
  MessageSquare,
  FileText
} from 'lucide-react';

interface Tab {
  value: string;
  label: string;
  icon: React.ElementType;
}

interface BusinessRulesTabNavigationProps {
  activeTab: string;
  tabs: Tab[];
}

const BusinessRulesTabNavigation: React.FC<BusinessRulesTabNavigationProps> = ({
  activeTab,
  tabs
}) => {
  return (
    <TabsList className="bg-gray-50 p-2 rounded-lg w-full flex flex-wrap gap-2 h-auto">
      {tabs.map((tab) => (
        <TabsTrigger 
          key={tab.value}
          value={tab.value} 
          className={`
            flex flex-col items-center space-y-1 p-3 rounded-lg transition-all duration-300 group relative overflow-hidden min-h-[60px] flex-1 min-w-[140px]
            ${activeTab === tab.value 
              ? 'bg-white text-primary-600 shadow-md border border-primary-200' 
              : 'hover:bg-white/50 hover:shadow-sm text-gray-600 hover:text-gray-900'
            }
          `}
        >
          <div className={`
            w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-300
            ${activeTab === tab.value 
              ? 'bg-primary-100' 
              : 'bg-gray-200 group-hover:bg-gray-300'
            }
          `}>
            <tab.icon className={`
              w-4 h-4 transition-all duration-300
              ${activeTab === tab.value 
                ? 'text-primary-600' 
                : 'text-gray-500 group-hover:text-gray-700'
              }
            `} />
          </div>
          <span className="font-medium text-xs text-center leading-tight">{tab.label}</span>
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export default BusinessRulesTabNavigation;
